<template>
<div>
  <div v-if="!showApp">
    <AberrantNetworkAlert :showComponent="showComponent" :showApp="showApp" :isError="isError" :messages="messages"  />
  </div>
  <div v-if="showApp">
    <ApplicationLandingPage v-if="showLandingPage"/>
    <ApplicationMainView v-if="!showLandingPage" />
  </div>
</div>
</template>

<script setup>

  const { profile, context, criteriaContext, hasSearched, hideLandingPage } = useFCPModel()
  const model = useFCPModel()  
  let { showApp, showComponent, isError, messages } = useProfileInfo(profile.value)
  const { handleAuthBroadcast, broadcastPageload } = useBroadcastApi('status_channel')

  const showLandingPage = computed(() => {
    const isBoxCanyon = context.value.networkId ? true : false
    return !profile.value.isAuthenticated && isBoxCanyon && !hasSearched.value && !hideLandingPage.value
  })

  handleAuthBroadcast(profile.value)

  onMounted(() => {
    broadcastPageload()

    const { manageUrls, clearSafelinkItems } = useUrlManager(model)
    // clear out safelink-pertaining items, if authenticated
    if (profile.value?.isAuthenticated && context.value.safelink) {
      clearSafelinkItems()
    }
    manageUrls()
    // const { buildPills } = useFilters(model)
    // buildPills()
  })
</script>
